import angular from "angular"

const app = angular.module("appModule")
const BASE_URL = API_HOST

app.factory("UserService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "users/:user/",
      { user: "@user" },
      {
        get: {
          method: "GET",
          params: {
            categoryId: "@categoryId",
            planId: "@planId",
            actionId: "@actionId"
          },
          isArray: false
        },
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])
